import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Layout from "./layout/Layout";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Notfound from "./pages/Notfound";
import Projets from "./pages/Projets";
import Animation from "./pages/Animation";
import LivreDOr from "./pages/LivreDOr";
import PreLoader from "./components/PreLoader";

function App() {
  return (
    <>
      <div className="app">
      <PreLoader />
        <Router>
          <Routes>
            <Route
              path="/"
              element={
                <Layout>
                  <Home />
                </Layout>
              }
            />
            <Route
              path="/projets"
              element={
                <Layout>
                  <Projets />
                </Layout>
              }
            />
            <Route
              path="/animation"
              element={
                <Layout>
                  <Animation />
                </Layout>
              }
            />
            <Route
              path="/contact"
              element={
                <Layout>
                  <Contact />
                </Layout>
              }
            />
            <Route
              path="/livre-dor"
              element={
                <Layout>
                  <LivreDOr />
                </Layout>
              }
            />
            <Route
              path="*"
              element={
                <Layout>
                  <Notfound />
                </Layout>
              }
            />
          </Routes>
        </Router>
      </div>
    </>
  );
}

export default App;
